import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//COMPONENTS
import Label from "../../../../../../../Components/Label";
import ButtonCustom from "../../../../../../../Components/ButtonCustom";
import { Box } from "../../../../../../../Components/CustomUi/box";
import { CopiableRow } from "../../../../../../../Components/CustomUi/copiableRow";
import { ItemRequest } from "../../../../../../../services/logs";
import { copyJson } from "./meta";

//PROPS
interface Props {
    request_selected: ItemRequest;
}

export const HeadersRequest: React.FC<Props> = ({ request_selected }) => {

    const { contentType, host, origin, referer, userAgent } = request_selected?.descricao?.headers ?? {};

    return (
        <Box padding={15}>
            <Label style={{fontWeight: 700, color: 'var(--text-color-light)', fontSize:13}} >Cabeçalho da requisição</Label>

            <div style={{display:'flex',flexDirection:'column'}}>
                <CopiableRow 
                    atribute="contentType"
                    value={contentType}
                />
                <CopiableRow 
                    atribute="host"
                    value={host}
                />
                <CopiableRow 
                    atribute="origin"
                    value={origin}
                />
                <CopiableRow 
                    atribute="referer"
                    value={referer}
                />
                <CopiableRow 
                    atribute="userAgent"
                    value={userAgent}
                    isLast
                />
            </div>

            <ButtonCustom 
                onClick={()=>{copyJson(request_selected)}}
                type='secondary'
                style={{alignSelf:'flex-start'}}
                icon={<FontAwesomeIcon icon={faCopy} />}
            >
                Copiar JSON
            </ButtonCustom>
            
        </Box>
    )
}